export default function PageMain({children}) {
    return (
        <div className="pb-[15px] px-[25px] relative">
            {children}
        </div>
    )
}